"use strict";

exports.__esModule = true;
var safeHasOwnProperty = function safeHasOwnProperty(obj, prop) {
  return obj ? Object.prototype.hasOwnProperty.call(obj, prop) : false;
};
exports["default"] = safeHasOwnProperty;